import React, { useEffect } from 'react'
import Title from '../Components/Title';
import Skill from '../Components/Skill';
import { AiFillHtml5 } from 'react-icons/ai';
import { DiCss3, DiJavascript, DiSass } from 'react-icons/di';
import { RiReactjsFill } from 'react-icons/ri';
import { SiRedux, SiMui, SiMongodb, SiTypescript, SiExpress, SiPostman, SiJquery } from 'react-icons/si';
import { FaBootstrap, FaGitAlt, FaNodeJs } from 'react-icons/fa';
import { MainLayout, InnerLayout } from '../Styles/mainLayouts';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';


const SkillsStyled = styled.section`
    .skills{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-row-gap: 2rem;
        grid-column-gap: 3rem;
        .icon{
            font-size:67px;
        }
        
        @media screen and (max-width: 950px){
            grid-template-columns: repeat(3, 1fr);
        }
        @media screen and (max-width: 700px){
            grid-template-columns: repeat(2, 1fr);
            overflow: hidden;
            padding-bottom: 28px;
        }
        @media screen and (max-width: 500px){
            grid-template-columns: repeat(1, 1fr);
        }
    }
`;


const SkillsPage = ({ theme }) => {

    useEffect(() => {
        AOS.init({ duration: 2500, })
    }, [])

    const skills = [
        { skill: "HTML5", icon: <AiFillHtml5 className="icon" /> },
        { skill: "CSS3", icon: <DiCss3 className="icon" /> },
        { skill: "CSS3", icon: <DiSass className="icon" /> },
        { skill: "JavaScript", icon: <DiJavascript className="icon" /> },
        { skill: "JQuery", icon: <SiJquery className="icon" /> },
        { skill: "TypeScript", icon: <SiTypescript className="icon" /> },
        { skill: "React Js", icon: <RiReactjsFill className="icon" /> },
        { skill: "Redux", icon: <SiRedux className="icon" /> },
        { skill: "Bootstrap", icon: <FaBootstrap className="icon" /> },
        { skill: "Material-UI", icon: <SiMui className="icon" /> },
        { skill: "Node Js", icon: <FaNodeJs className="icon" /> },
        { skill: "Express Js", icon: <SiExpress className="icon" /> },
        { skill: "Mongo DB", icon: <SiMongodb className="icon" /> },
        { skill: "Git", icon: <FaGitAlt className="icon" /> },
        { skill: "Postman", icon: <SiPostman className="icon" /> },
    ]

    return (
        <MainLayout>
            <SkillsStyled>
                <Title title={'My Skills'} />
                {/* <Title title={'My Skills'} span={'my skills'} /> */}
                <InnerLayout>
                    <div className="skills">
                        {skills.map((el, i) => (
                            i % 2 === 0 ?
                                <div key={i} data-aos="fade-right">
                                    <Skill
                                        title={el.skill}
                                        icon={el.icon}
                                    />
                                </div>
                                : <div key={i} data-aos="fade-left">
                                    <Skill
                                        title={el.skill}
                                        icon={el.icon}
                                    />
                                </div>
                        ))}
                    </div>
                </InnerLayout>
            </SkillsStyled>
        </MainLayout>
    )
}

export default SkillsPage